import React from "react";
import {
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { styled } from "@mui/material/styles";
import '../FormTable1/FormTable.css';

const FormTableContainer = styled('div')({
  // Add any styles you need for the container
  padding: '20px',
});

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '22px',
}));

const FormTable = ({ rows, onSubmit,onReset,visibleColumns }) => {

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    onSubmit();
  };


  
  return (
    <FormTableContainer>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {rows.map(
            (row, index) => (
              <Grid
                container
                item
                spacing={1}
                sx={{ padding:'0px' ,mt:0 }}
                key={index}
                alignItems="center"
              >
                <Grid item xs={12} sm={2} md={2.5}>
                  <Typography
                    fontFamily="DiodrumRegular"
                    fontSize="16px"
                    textAlign="left"
                    
                  >
                    {row.label}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2} md={1.5}>
                  {row.input}
                </Grid>
                {visibleColumns.input_1 && (
                  <Grid item xs={12} sm={2} md={1.5}>
                    {row.input_1}
                  </Grid>
                )}
                {visibleColumns.input_2 && (
                  <Grid item xs={12} sm={2} md={1.5}>
                    {row.input_2}
                  </Grid>
                )}
                {visibleColumns.input_3 && (
                  <Grid item xs={12} sm={2} md={1.5}>
                    {row.input_3}
                  </Grid>
                )}
                {visibleColumns.input_4 && (
                  <Grid item xs={12} sm={2} md={1.5}>
                    {row.input_4}
                  </Grid>
                )}
              </Grid>
            )
          )}
        </Grid>
        <Grid item xs={12} mt={3}>
          <StyledButton variant='outlined' color='warning' onClick={handleSubmit} type="submit">
            Calculate
          </StyledButton>
          <StyledButton variant='outlined' color='inherit' onClick={onReset} sx={{ ml: 2 }}>
            Reset
          </StyledButton>
        </Grid>
      </form>
    </FormTableContainer>
  );
};

export default FormTable;